import React from "react";
import CourseCard from "./CourseCard";

const Course: React.FC = () => {
  const courses = [
    // Skiing Courses
    {
      title: "Skiing - Basic Level",
      image: "/images/courses/sk1.jpg", // Replace with actual image path
      description:
        "Perfect for beginners to learn skiing basics in a fun environment.",
      duration: "5 days",
    },
    {
      title: "Skiing - Intermediate Level",
      image: "/images/courses/sk3.jpg", // Replace with actual image path
      description:
        "Improve your skiing skills and conquer intermediate slopes.",
      duration: "7 days",
    },
    {
      title: "Skiing - Advanced Level",
      image: "/images/courses/sb1.jpg", // Replace with actual image path
      description: "Master skiing techniques and tackle advanced slopes.",
      duration: "10 days",
    },

    // Snowboarding Courses
    {
      title: "Snowboarding - Basic Level",
      image: "/images/courses/sb3.jpg", // Replace with actual image path
      description: "Learn the essentials of snowboarding with expert guidance.",
      duration: "5 days",
    },
    {
      title: "Snowboarding - Intermediate Level",
      image: "/images/courses/sb2.jpg", // Replace with actual image path
      description:
        "Build confidence and explore intermediate snowboarding tricks.",
      duration: "7 days",
    },
    {
      title: "Snowboarding - Advanced Level",
      image: "/images/courses/sb4.jpg", // Replace with actual image path
      description: "Push your limits with advanced snowboarding techniques.",
      duration: "10 days",
    },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-6 p-4">
      {courses.map((course, index) => (
        <CourseCard key={index} {...course} />
      ))}
    </div>
  );
};

export default Course;
